import { Navigate, useNavigate } from "react-router-dom";
import React, { JSX, useEffect, useState } from "react";

export function RequireAuth({ children }: { children: JSX.Element }) {
    const [isChecking, setIsChecking] = useState(true);
    const [isValid, setIsValid] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            // no token → go to login
            setIsChecking(false);
            setIsValid(false);
            navigate("/login", { replace: true });
            return;
        }

        // validate token with backend
        fetch("/auth/me", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(async (res) => {
            if (res.ok) {
                setIsValid(true);
            } else if (res.status === 401 || res.status === 403) {
                // invalid token → remove & redirect
                localStorage.removeItem("token");
                navigate("/login", { replace: true });
            } else {
                // optionally handle other errors
                console.error("Error checking auth", res.status);
            }
        }).catch((err) => {
            console.error("Error calling /auth/me", err);
            localStorage.removeItem("token");
            navigate("/login", { replace: true });
        }).finally(() => {
            setIsChecking(false);
        });
    }, [navigate]);

    if (isChecking) {
        return <div>Checking login…</div>; // or spinner
    }

    if (!isValid) {
        // Redirect is triggered via navigate above; render nothing here
        return null;
    }

    return children;
}